import React from 'react'
import {useLocation} from 'react-router-dom'

import AboutSectionHeader from '../../features/about/components/AboutSectionHeader'
import BondsSectionHeader from '../../features/bonds/components/BondsSectionHeader'
import CareersSectionHeader from '../../features/careers/components/CareersSectionHeader'
import ProductsSectionHeader from '../../features/products/components/ProductsSectionHeader'
import {APP_ROUTES} from '../../routes/routes'

const HeaderSubMenu = () => {
  const location = useLocation()

  const parsePath = path => path.replace(/\//g, '')

  const pathSubMenu = {
    [parsePath(APP_ROUTES.CAREERS)]: <CareersSectionHeader />,
    [parsePath(APP_ROUTES.CAREERS_LIST)]: <CareersSectionHeader />,
    [parsePath(APP_ROUTES.CAREERS_DETAIL)]: <CareersSectionHeader />,
    [parsePath(APP_ROUTES.ABOUT)]: <AboutSectionHeader />,
    [parsePath(APP_ROUTES.PRODUCTS)]: <ProductsSectionHeader />,
    [parsePath(APP_ROUTES.BONDS)]: <BondsSectionHeader />
  }

  return pathSubMenu[parsePath(location.pathname)] ?? null
}

export default HeaderSubMenu
